import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { AuditReportViewer } from "../components/AuditReportViewer";

const AuditReportModal = ({ show, close, report, modalName = "Audit Report", actionType = "audit_file" }) => {
  return (
    <Modal
      show={show}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          {modalName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <AuditReportViewer report={report} close={close} actionType={actionType} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AuditReportModal;